<template>
  <el-dialog
    v-model="dialogStatus"
    :close-on-click-modal="false"
    @close="close"
    :title="dialogTitle"
    :width="width"
    append-to-body>
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="广告主名称" prop="advertiserName">
        <el-input v-model="form.advertiserName" size="medium" placeholder="请输入广告主名称"/>
      </el-form-item>
      <el-form-item label="联系电话" prop="contactPhone">
        <el-input v-model="form.contactPhone" size="medium" placeholder="请输入联系电话"/>
      </el-form-item>
      <el-form-item label="展示监测 URL" prop="impTrackUrl">
        <el-input v-model="form.impTrackUrl" size="medium" placeholder="请输入展示监测 URL"/>
      </el-form-item>
      <el-form-item label="点击监测 URL" prop="clickTrackUrl">
        <el-input v-model="form.clickTrackUrl" size="medium" placeholder="请输入点击监测 URL"/>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio :label="0">禁用</el-radio>
          <el-radio :label="1">启用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div style="text-align: right;">
      <el-button @click="close" size="medium">取消</el-button>
      <el-button @click="submit" type="primary" size="medium" :loading="submitLoading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addAdvertiser, updateAdvertiser } from '@/api/ocpx/advertiser'

const defaultForm = {
  advertiserName: undefined,
  contactPhone: undefined,
  impTrackUrl: undefined,
  clickTrackUrl: undefined,
  status: 1
}

export default {
  props: {
    title: String,
    width: {
      type: Number,
      default: 600
    }
  },
  emits: ['submit'],
  data () {
    return {
      dialogStatus: false,
      submitLoading: false,
      form: Object.assign({}, defaultForm),
      rules: {
        advertiserName: [{ required: true, message: '请输入广告主名称', trigger: 'blur' }],
        contactPerson: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        contactPhone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        callbackUrl: [{ required: true, message: '请输入回调地址', trigger: 'blur' }],
        impTrackUrl: [{ required: false, message: '请输入展示监测 URL', trigger: 'blur' }],
        clickTrackUrl: [{ required: false, message: '请输入点击监测 URL', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  computed: {
    dialogTitle () {
      return (this.title ? this.title : '') + (this.form.id ? '编辑' : '新增')
    }
  },
  methods: {
    show (data) {
      this.dialogStatus = true
      if (data) {
        this.form = Object.assign({}, data)
      }
    },
    close () {
      this.dialogStatus = false
      this.reset()
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.id) {
            this.doUpdate(this.form)
          } else {
            this.doAdd(this.form)
          }
        }
      })
    },
    doAdd (form) {
      this.submitLoading = true
      addAdvertiser(form).then(res => {
        if (res.code === 200) {
          this.$message.success('新增成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    doUpdate (form) {
      this.submitLoading = true
      updateAdvertiser(form).then(res => {
        if (res.code === 200) {
          this.$message.success('编辑成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    reset () {
      this.form = Object.assign({}, defaultForm)
      this.$refs.form && this.$refs.form.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 15px;
}
</style>
